class EnvironmentVariableError extends Error {
  constructor(key: string) {
    super(`Falsy Environment Variable: "${key}"`);

    this.name = 'EnvironmentVariableError';
  }
}

export default EnvironmentVariableError;
